import { ToastProps } from 'types';
import { create } from 'zustand';

/**
 * `backgroundColor` on these is not rendered by anything -- Toast styles every
 * variant from `_blocks.scss`, keyed on the title class. The values are stale
 * as a result (Progress carries #EBF3FE where the spec is #ecf4fc), and left
 * alone rather than corrected, because correcting one of six would suggest they
 * mean something. Change the stylesheet, not this table.
 */
export const TOAST_PROPERTIES: ToastProps[] = [
  {
    id: Math.floor(Math.random() * 101 + 1),
    title: 'Success',
    description: 'This is a success toast component',
    backgroundColor: '#5cb85c',
  },
  {
    id: Math.floor(Math.random() * 101 + 1),
    title: 'Danger',
    description: 'This is an error toast component',
    backgroundColor: '#d9534f',
  },
  {
    id: Math.floor(Math.random() * 101 + 1),
    title: 'Info',
    description: 'This is an info toast component',
    backgroundColor: '#5bc0de',
  },
  {
    id: Math.floor(Math.random() * 101 + 1),
    title: 'Warning',
    description: 'This is a warning toast component',
    backgroundColor: '#f0ad4e',
  },
  {
    id: Math.floor(Math.random() * 101 + 1),
    title: 'Draft',
    description: 'This is an draft toast component',
    backgroundColor: '#F3F9FF',
  },
  {
    id: Math.floor(Math.random() * 101 + 1),
    title: 'Progress',
    description: 'This is a progress toast component',
    backgroundColor: '#EBF3FE',
  },
];
/**
 * Ids on TOAST_PROPERTIES are generated once per variant at module load, so every Success toast
 * would otherwise share one id and a per-toast deadline could remove the wrong one. This makes
 * each raised toast individually addressable.
 */
let nextToastId = 0;

interface useToastStore {
  list: ToastProps[];
  showToast: (
    value: 'Success' | 'Danger' | 'Info' | 'Warning' | 'Draft' | 'Progress',
    message: string,
    autoDeleteTime?: number
  ) => void;
  removeAllToast(nextState: Partial<useToastStore>): void;
}

const useToaster = create<useToastStore>(set => ({
  list: [],
  showToast: (value, message, autoDeleteTime) => {
    const toastProperties = TOAST_PROPERTIES.find(toast => toast.title === value);
    nextToastId += 1;
    set(
      (state: any) => ({
        list: [
          ...state.list,
          {
            ...toastProperties,
            id: nextToastId,
            description: message,
            shownAt: Date.now(),
            ...(autoDeleteTime ? { autoDeleteTime } : {}),
          },
        ],
      }),
      false
    );
  },
  removeAllToast: (nextState: any) => set(() => ({ ...nextState })),
}));

export default useToaster;
